import React from 'react';
import { Button } from './ui/button';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Download, FileText, FileSpreadsheet } from 'lucide-react';
import { toast } from 'sonner';
import { exportToCSV, exportToExcel, exportToPDF } from '../lib/exporters';

/**
 * Botão dropdown reutilizável para exportar uma tabela em CSV, Excel ou PDF.
 *
 * Props:
 *   columns  → Array<{ key, label, type?, decimals?, value?(row) }>
 *   rows     → Array<row>
 *   filename → string (sem extensão)
 *   title    → string (cabeçalho do ficheiro)
 *   subtitle → string opcional (apenas PDF)
 */
const ExportMenu = ({ columns, rows, filename, title, subtitle, disabled, testId = 'export-menu' }) => {
  const handle = (fn, label) => () => {
    if (!rows || !rows.length) {
      toast.error('Não há dados para exportar');
      return;
    }
    try {
      fn({ columns, rows, filename, title, subtitle });
      toast.success(`${label} exportado com sucesso!`);
    } catch (err) {
      toast.error(`Erro ao exportar ${label}: ${err.message}`);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" disabled={disabled || !rows?.length} data-testid={testId}>
          <Download className="h-4 w-4 mr-2" />
          Exportar
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={handle(exportToCSV, 'CSV')} className="cursor-pointer" data-testid={`${testId}-csv`}>
          <FileText className="h-4 w-4 mr-2 text-green-600" /> Exportar CSV
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handle(exportToExcel, 'Excel')} className="cursor-pointer" data-testid={`${testId}-xlsx`}>
          <FileSpreadsheet className="h-4 w-4 mr-2 text-green-700" /> Exportar Excel
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handle(exportToPDF, 'PDF')} className="cursor-pointer" data-testid={`${testId}-pdf`}>
          <FileText className="h-4 w-4 mr-2 text-red-600" /> Exportar PDF
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ExportMenu;
